import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vconsole from "vconsole";
import {
    ActionSheet,
    Cascader,
    Checkbox,
    Circle,
    DatetimePicker,
    Dialog,
    DropdownItem,
    DropdownMenu,
    Icon,
    List,
    Loading,
    Overlay,
    Picker,
    Popup,
    PullRefresh,
    Rate,
    Slider,
    Stepper,
    Sticky,
    Swipe,
    SwipeItem,
    Tab,
    Tabs,
    Toast,
} from 'vant';
import 'vant/lib/index.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "./common/font/font.css";
import {getUrlParam, isInMiniProgram} from "@/utils";
import tools from "@/common/js/tools";

if (getUrlParam('sessionId')) {//判断为小程序内嵌页面
    window.temporarySessionId = getUrlParam('sessionId');
}
if(getUrlParam('zsbSessionId')){
    window.tempZsbMiniAppSessionId = getUrlParam('zsbSessionId');
}

if (getUrlParam('gkMiniAppSessionId')) {//判断为高会小程序内嵌页面
    tools.setCookie('msid', getUrlParam('gkMiniAppSessionId'));
    window.tempGkMiniAppSessionId = getUrlParam('gkMiniAppSessionId');
    store.commit('setMiniAppStatus', true)
}

// isInMiniProgram().then(res=>{
//     store.commit('setMiniAppStatus', res)
// })

if (process.env.NODE_ENV != 'production' || process.env.NODE_ENV == 'staging') {
    new Vconsole()
}

const app = createApp(App);

app.use(Swipe);
app.use(SwipeItem);
app.use(Overlay);
app.use(PullRefresh);
app.use(Picker);
app.use(Icon);
app.use(Rate);
app.use(Dialog);
app.use(Toast);
app.use(Checkbox);
app.use(Popup);
app.use(Tab);
app.use(Tabs);
app.use(List);
app.use(Loading);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Slider);
app.use(Circle);
app.use(Stepper)
app.use(ActionSheet);
app.use(ElementPlus)
app.use(Cascader);
app.use(DatetimePicker)
app.use(Sticky);

app.config.compilerOptions.isCustomElement = (tag) => {
    return tag.startsWith('wx-open-launch-weapp')
}
app.use(store).use(router).mount('#app');
